export const WEBVIEW_HEIGHT_VALUES = {
  compact: 'Some of Screen',
  tall: 'Most of Screen',
  full: 'Full Screen',
};
